import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import Icallphone from './IcallPhone/Icallphone';
import Footer from './Components/Footer';
import About from './About/About';
import HelpCenter from './HelpCenter/HelpCenter';
import Header from './Components/Header';
import Features2 from './Features2/Features2';
import axios from 'axios';
import theme from './theme';
import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import Privacy from './Permission/Privacy';


const App = () => {
  // const [loading, setLoading] = useState(true);
  // const location = useLocation();

  const [data, setData] = useState(null);
  const token = "cowberryapps.icallphonedialer.contactbook";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `http://localhost:5000/scrape?url=https://play.google.com/store/apps/details?id=${token}`
        );
        console.log("Full Response:", response.data);
        setData(response.data);

        localStorage.setItem("appData", JSON.stringify(response.data));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  // ------ loader ------
  // useEffect(() => {
  //   setLoading(true);
  //   const startTime = Date.now();

  //   const handleLoad = () => {
  //     const elapsed = Date.now() - startTime;
  //     const remainingTime = 3000 - elapsed;

  //     const timer = setTimeout(() => {
  //       setLoading(false);
  //     }, remainingTime > 0 ? remainingTime : 0);

  //     return () => clearTimeout(timer);
  //   };

  //   if (document.readyState === 'complete') {
  //     handleLoad();
  //   } else {
  //     window.addEventListener('load', handleLoad);
  //   }

  //   return () => {
  //     window.removeEventListener('load', handleLoad);
  //   };
  // }, [location]);

  return (
    <>
      <Header appData={data} />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<Icallphone />} />
          <Route path="/about" element={<About />} />
          <Route path="/help" element={<HelpCenter />} />
          <Route path="/Privacy" element={<Privacy />} />
          <Route path="/footer" element={<Footer />} />
          <Route path="/features" element={<Features2 />} />
        </Routes>
        {/* <Features2 /> */}
        {/* <Privacy /> */}
      </ThemeProvider>

    </>
  );
};

export default App;
